import React, { useEffect, useRef, useState } from 'react'
import { Button, Checkbox, Selector } from '../Elements';
import { useSelector } from 'react-redux';
import ConfirmationModal from '../ConfirmationModal';
import { FaEllipsisV } from 'react-icons/fa';
import { DropdownMenu } from '../FrostUI/Dropdown/DropdownMenu';
import commonNetwork from '../../../common/api/commonNetwork';
import { toast } from 'react-toastify';
import { formatCurrency } from '../../../lib/helpers';
import MaterailTable from '../Elements/MaterialTable';
import { ListItemIcon, Menu, MenuItem } from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';
import { muiMenuStyles } from '../../../constants/muiMenuStyles';
import { Form, Formik } from 'formik';
import FormObserver from '../FormElements/FormObserver';
import { FormCheckbox, FormSelector } from '../FormElements';
import { getSelectedValueFromId } from '../../../common/helpers/selectBoxHelper';
import SetInstallmentDetailModal from './SetInstallmentDetailModal';
import { getNavigationUrl } from '../../../common/helpers/navigationHelpers';
import { useNavigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { tenantState } from '../../../store/recoil/tenant/atoms';
import { InstallmentType, PaymentSetProps } from '../../pages/InsertUpdatePaymentSet';
import paymentApi from '../../../common/api/paymentApi';

type SetInstallmentsProps = {
    formValues: PaymentSetProps,
    setFormValues: any,
    setTabIndex: any,
    paymentSetId: number,
    installmentList: InstallmentType[],
    setInstallmentList: any,
}

const SetInstallments = React.forwardRef((props: SetInstallmentsProps) => {

    const { formValues, setFormValues, setTabIndex, paymentSetId, installmentList, setInstallmentList } = props;

    const { firmInformations } = useRecoilValue(tenantState);
    const { licenseKey, taxCode } = firmInformations;
    const classes = muiMenuStyles();
    const navigate = useNavigate();
    const goToPaymentSets = getNavigationUrl("/odeme-setleri");

    const navbarState = useSelector((state: any) => state.navbar);
    const sideBarOpen = navbarState.isOpen;

    const confirmModalRef = useRef();
    const tableRef = useRef();
    const installmentEditModalRef = useRef<any>();

    const [activePosList, setActivePosList] = useState<any[]>([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [dropdownAllValues, setDropdownAllValues] = useState<any>({});
    const isopenMenu = Boolean(anchorEl);

    const [submitLoading, setSubmitLoading] = useState<boolean>(false);

    useEffect(() => {
        selectActivePos();
    }, []);

    useEffect(() => {
        getInstallmentsByVp();
    }, [activePosList]);

    useEffect(() => {
        if (activePosList.length > 0) {
            setFormValues((prevValues: any) => ({
                ...prevValues,
                vp: activePosList[0].value
            }))
        }
    }, [activePosList]);


    const selectActivePos = async () => {
        const data = await commonNetwork.get("/virtualpos/actives");
        var poslist = [];
        if (data.isSuccess) {
            var res: any = data.data;
            for (let x = 0; x < formValues.vpList.length; x++) {
                for (let i = 0; i < res.length; i++) {
                    const element = res[i];
                    if (formValues.vpList[x] == element.vpid) {
                        poslist.push({
                            value: element.vpid,
                            label: element.vpdisplayname ? element.vpdisplayname : element.bankname,
                            bankId: element.bankid
                        });
                    }
                }
            }
            setActivePosList(poslist);

        } else {
            toast.error(data.errorMessage);
        }
    }

    const getInstallmentsByVp = async () => {
        // Eksik vpId'leri bul
        const missingActiveposList = activePosList.filter(
            activePos => !installmentList.some(installment => installment.vpId === activePos.value)
        );

        const fetchAndSetInstallments = async (vpId: any, bankId: any) => {
            const params = { vpId, bankId };

            try {
                const result = await commonNetwork.get("/installment/all-by-vp", params);

                if (result && result.data) {
                    const longestInstallmentList = result.data.reduce(
                        (longest: any, current: any) =>
                            current.installmentList.length > longest.installmentList.length
                                ? current
                                : longest,
                        { installmentList: [] }
                    );

                    setInstallmentList((prevValues: any) => [
                        ...prevValues,
                        {
                            vpId,
                            vpInstallment: [longestInstallmentList]
                        }
                    ]);
                }
            } catch (error) {
                console.error("Error fetching installments:", error);
            }
        };

        if (paymentSetId === undefined) {
            // Tüm activePosList için installment fetch
            for (const activePos of activePosList) {
                const bankId = activePos.bankId;
                if (bankId !== undefined) {
                    await fetchAndSetInstallments(activePos.value, bankId);
                }
            }
        } else if (missingActiveposList.length > 0) {
            // Sadece eksik olanlar için installment fetch
            for (const activePos of missingActiveposList) {
                const bankId = activePos.bankId;
                if (bankId !== undefined) {
                    await fetchAndSetInstallments(activePos.value, bankId);
                }
            }
        }
    };


    const handleClickMenu = (event: any, row: any) => {
        setDropdownAllValues(row);
        setAnchorEl(event.currentTarget);
    };

    const setInstallmentElement = (installmentItem: any, name: any, value: any) => {
        // make a copy of installmentList
        const parsedPos = JSON.parse(JSON.stringify(installmentList));

        // find current activePosList index
        const activePosListIndex = activePosList.findIndex(x => x.value == formValues.vp);

        const brandIndex = parsedPos.findIndex(
            (w: any) => w.vpId === activePosList[activePosListIndex]?.value
        );

        if (formValues.isInstallmentApplyToAll) {
            // Apply the same settings to all POS
            parsedPos.forEach((pos: any, i: any) => {
                const posInstallments = pos.vpInstallment[0].installmentList;
                const itemIndex = posInstallments.findIndex(
                    (w: any) => w.installment === installmentItem.installment
                );

                if (itemIndex !== -1) {
                    posInstallments[itemIndex][name] = value;
                }
            });
        } else {
            // Update only on relevant POS
            if (brandIndex !== -1) {
                const brandInstallments = parsedPos[brandIndex].vpInstallment[0].installmentList;
                const itemIndex = brandInstallments.findIndex(
                    (w: any) => w.installment === installmentItem.installment
                );

                if (itemIndex !== -1) {
                    brandInstallments[itemIndex][name] = value;
                }
            }
        }

        setInstallmentList(parsedPos);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const editInstallmentClick = (row: any) => {
        installmentEditModalRef.current.openModal(row);
    }

    const deleteInstallmentClick = (item: any) => { }

    const getLastInstallment = () => { }

    const lastInstallment = getLastInstallment();

    const onSubmit = async () => {
        try {
            setSubmitLoading(true);
            const apiParams = { licenseKey: licenseKey, taxCode: taxCode };
            const params: any = {
                paymentSetId: paymentSetId,
                setDesc: formValues.paymentSetDesc,
                isDefault: formValues.isDefaultSet,
                status: formValues.status,
                setInstalment: [],
                insertUserId: localStorage.getItem("_us_d"),
                isInstallmentApplyAll: formValues.isInstallmentApplyToAll,
                lastUserId: localStorage.getItem("_us_d")
            };

            if (formValues.isInstallmentApplyToAll) {
                // Find the installment information of the selected VP
                const selectedVP = installmentList.find(item => item.vpId === formValues.vp);

                if (selectedVP) {
                    const selectedInstallmentInfo = selectedVP.vpInstallment[0].installmentList.map(inst => ({
                        installment: inst.installment,
                        commissionAmount: typeof inst.commissionAmount === "string"
                            ? parseFloat(inst.commissionAmount)
                            : inst.commissionAmount,
                        status: inst.status,
                        isBusiness: true,
                        isIndividual: true
                    }));

                    // Assign the selected VP's installment information to other VPs, restrict according to the maximum number of installments
                    for (let x = 0; x < installmentList.length; x++) {
                        const vpInstallments = installmentList[x].vpInstallment;
                        const maxInstallments = vpInstallments[0].installmentList.length; // Maximum number of installments for this VP

                        for (let y = 0; y < formValues.vpList.length; y++) {
                            if (formValues.vpList[y] == installmentList[x].vpId) {
                                params.setInstalment.push({
                                    vpId: installmentList[x].vpId,
                                    installmentInfo: selectedInstallmentInfo.slice(0, maxInstallments), // Limit length
                                    bankInfo: {
                                        bankId: vpInstallments[0].bankBrand.bankId
                                    }
                                });
                            }
                        }
                    }
                }
            } else {
                // Use your own installment information for each VP
                for (let x = 0; x < installmentList.length; x++) {
                    const vpInstallments = installmentList[x].vpInstallment;
                    const installmentInfo = vpInstallments[0].installmentList.map(inst => ({
                        installment: inst.installment,
                        commissionAmount: typeof inst.commissionAmount === "string"
                            ? parseFloat(inst.commissionAmount)
                            : inst.commissionAmount,
                        status: inst.status,
                        isBusiness: true,
                        isIndividual: true
                    }));

                    for (let y = 0; y < formValues.vpList.length; y++) {
                        if (formValues.vpList[y] == installmentList[x].vpId) {
                            params.setInstalment.push({
                                vpId: installmentList[x].vpId,
                                installmentInfo,
                                bankInfo: {
                                    bankId: vpInstallments[0].bankBrand.bankId
                                }
                            });
                        }
                    }
                }
            }
            let result: any;

            if (paymentSetId > 0) {
                result = await paymentApi.post("/paymentset/update-paymentset", params, apiParams);
            } else {
                result = await paymentApi.post("/paymentset", params, apiParams);
            }

            if (result.isSuccess) {
                const successMessage = paymentSetId > 0 ? "Ödeme Kuralı Güncellendi" : "Ödeme Kuralı Oluşturuldu";
                toast.success(successMessage);
                navigate(goToPaymentSets);
            } else {
                toast.error(result.errorMessage);
            }
        } catch (error) {

        } finally {
            setSubmitLoading(false);
        }
    };


    const onUpdateAllValues = (values: any) => {

        // installment list index in installment list
        const installmentListIndex = installmentList.findIndex(x => x.vpId === formValues.vp);

        if (installmentListIndex === -1) {
            toast.error("installmentList içinde ilgili vpId bulunamadı! Taksit listesi yüklendiyse bu hatayı dikkate almayın.");
            return;
        }

        // Make a copy of the existing installmentList
        const updatedInstallmentList = JSON.parse(JSON.stringify(installmentList));

        // Related installation list
        const installmentDetail = updatedInstallmentList[installmentListIndex].vpInstallment[0].installmentList;

        // Find and update target installment
        const installmentIndex = installmentDetail.findIndex(
            (x: any) => x.installment === values.installment
        );

        if (installmentIndex === -1 && paymentSetId === undefined) {
            toast.error("İlgili installment bulunamadı!");
            return;
        }

        installmentDetail[installmentIndex] = {
            ...installmentDetail[installmentIndex],
            ...values,
        };

        setInstallmentList(updatedInstallmentList);

    };


    const DropdownMenu = () => {
        return (
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={isopenMenu}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
                classes={{
                    paper: classes.paper,
                }}
            >

                <MenuItem onClick={() => {
                    setAnchorEl(null);
                    editInstallmentClick(dropdownAllValues);
                }}>
                    <ListItemIcon>
                        <Edit fontSize="small" />
                    </ListItemIcon>
                    Düzenle
                </MenuItem>

                {lastInstallment == dropdownAllValues.installment ? (

                    <MenuItem onClick={() => {
                        setAnchorEl(null);
                        deleteInstallmentClick(dropdownAllValues)
                    }}>
                        <ListItemIcon>
                            <Delete fontSize="small" />
                        </ListItemIcon>
                        Sil
                    </MenuItem>
                ) : null}
            </Menu>
        );
    }

    const headerCells = [
        {
            id: 'operations',
            numeric: false,
            label: 'İşlemler',
            exceptToExcel: true,
            isRender: true,
            disableSortIcon: true,
            className: "w-[60px]",
            renderRow: (row: any) => {

                return (
                    <div className="flex flex-row justify-around items-center">

                        <a id="basic-button"
                            aria-controls={isopenMenu ? 'basic-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={isopenMenu ? 'true' : undefined}
                            className="cursor-pointer"
                            onClick={(event) => handleClickMenu(event, row)}>
                            <FaEllipsisV
                                className="block sm:block ml-2 h-3 w-3 font-light"

                            />
                        </a>
                        <DropdownMenu>

                        </DropdownMenu>

                    </div>
                );

            }
        },
        {
            id: "installment",
            isprimary: true,
            hide: true
        },
        {
            label: "Taksit",
            isRender: true,
            hideSortIcon: true,
            renderRow: (item: any) => (
                <div className="my-2 flex flex-row justify-start col-span-2 ">
                    <Checkbox
                        label={item.installment === 1 ? "Peşin" : `${item.installment} Taksit`}
                        type="checkbox"
                        onChange={(ev: any) => setInstallmentElement(item, "status", ev.target.checked)}
                        checked={item.status} // Güncellenmiş `status` buraya yansıtılacak
                        id={`${item.installment}-status`}
                    />

                </div>
            )
        },
        {
            id: "commissionAmount",
            label: "Komisyon Oranı",
            isRender: true,
            hideSortIcon: true,
            forcealign: "left",
            renderRow: (item: any) => (
                <div>
                    {formatCurrency(item.commissionAmount, true)}
                </div>
            )
        },
    ];

    return (
        <div>
            <ConfirmationModal ref={confirmModalRef}></ConfirmationModal>
            <SetInstallmentDetailModal ref={installmentEditModalRef} updateCallBack={onUpdateAllValues} />
            <div className="m-4 pb-10 p-4 bg-white shadow-md rounded-md  !mb-20">
                <div className="flex flex-row items-center mt-4 sm:mt-4   ">
                    <h1 className="font-bold text-contrast-90">
                        Taksit ve Komisyon Ayarları
                    </h1>
                </div>
                <Formik
                    initialValues={formValues}
                    enableReinitialize
                    onSubmit={onSubmit}
                >
                    {({
                        values,
                        setFieldValue
                    }) => (
                        <>
                            <Form className='w-full' >
                                <FormObserver
                                    watch={(val: any) => {
                                        setFormValues(val);
                                    }}
                                />
                                <div className=" mt-4 sm:mt-4 px-8 sm:px-4  flex flex-row items-center w-full">
                                    <FormSelector
                                        options={activePosList}
                                        name="vp"
                                        value={getSelectedValueFromId(values.vp, activePosList)}
                                        onChange={setFieldValue}
                                        className=" w-[250px]"
                                        label="POS Seç"
                                        isDisabled={formValues.isInstallmentApplyToAll}
                                    // isDisabled={isInstallmentApplyToAll}
                                    />
                                    <div className="mt-6">
                                        <FormCheckbox
                                            label={"Tüm POS'larda Aynı Ayarlar Uygulansın"}
                                            name="isInstallmentApplyToAll"
                                            type="checkbox"
                                            className="ml-2  flex items-center"
                                            onChange={setFieldValue}
                                            value={values.isInstallmentApplyToAll}
                                        />
                                    </div>
                                </div>


                                <div className={`w-full  bottom-button-fixed ${sideBarOpen ? " openedmenu-width" : " closedmenu-width"}`} >
                                    <div className="  ml-0 flex flex-row justify-end bg-white shadow-md ">
                                        <div className="m-4  p-0 space-x-4 flex flex-row">
                                            <Button
                                                size="lg"
                                                color="gray"
                                                hover="gray"
                                                type="button"
                                                callback={() => { setTabIndex("1") }}

                                            >
                                                Geri Dön
                                            </Button>

                                            <Button
                                                // loading={postLoading}
                                                type="submit" size="lg" color="primary" hover="primary"
                                                spanClass={"ml-1.5 mr-1.5"} loading={submitLoading}>
                                                Kaydet
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </Form>
                        </>
                    )}
                </Formik>
                <div className="mt-4 w-full">

                    <div className="flex flex-col space-y-2 w-full">

                        <MaterailTable
                            // isLoading={isInstallmentLoading}
                            // emptyMessage={isInstallmentLoading ? "Yükleniyor.." : " "}
                            ref={tableRef}
                            tableStyle={{
                                overflow: "hidden"
                            }}
                            isDisablePaging={true}
                            disableShadow={true}
                            className="p-2-i m-2-i"
                            headerCells={headerCells}
                            tableData={installmentList.find(x => x.vpId === formValues.vp)?.vpInstallment[0].installmentList || []}
                        >
                        </MaterailTable>
                    </div>
                </div>
            </div>
        </div>
    )
});

export default SetInstallments